<template>
  <div class="addStyle" @mouseup.stop @keyup.stop>
    <el-form ref="addForm" :model="addForm" :rules="rules" label-position="right" label-width="90px" size="small">
      <el-form-item label="问题截图:" @paste.native.stop="pasteFile" @mouseover.native="focusThis">
        <input ref="eventContainer" style="opacity: 0; position:absolute; z-index: -1;" type="text">
        <div class="MQcut">
          <div v-for="(item,index) in base64List" :key="index" class="uploadpic" @mouseenter="mouseenter(index)" @mouseleave="mouseleave(index)">
            <img :src="item.url" alt="截图" @click="startKss(index)">
            <div v-if="showDelete && item.hasKss && imageIndex == index" class="delete" @click="deleteImage(index)">
              <i class="el-icon-delete"></i>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="问题描述:" prop="checkContent">
        <el-input ref="checkContent" v-model="addForm.checkContent" type="textarea" rows="4" maxlength="200" show-word-limit style="max-height:490px" placeholder="请填写问题描述" @blur="syncComment"></el-input>
      </el-form-item>
      <el-form-item label="审图要点:" class="itemStyle">
        <template #label>
          <div class="labelStyle">
            <span>审图要点:</span>
            <el-button class="rcStyle" type="primary" plain size="small" @click="showImgPoint">关联审图要点</el-button>
          </div>
        </template>
        <el-input v-model="addForm.drawingReviewPoints" style="margin-left:0" type="textarea" readonly></el-input>
      </el-form-item>
      <el-form-item label="关联文件:" class="associatedFileStyle">
        <template #label>
          <div class="labelStyle">
            <span>关联文件:</span>
            <el-button class="rcStyle" type="primary" plain size="small" @click="showAssociatedFile">关联文档目录树</el-button>
            <el-button class="rcStyle" type="primary" plain size="small" @click="uploadFiles">本地上传</el-button>
          </div>
        </template>
        <ul>
          <li v-for="(item,index) in floderData" :key="index">
            <p class="fileNamestyle" :title="item.fileName">{{ item.fileName }}</p>
            <p style="margin-top:3px">
              <img :src="down" alt="下载" style="margin-right: 8px" @click="todown(item)">
              <img :src="del" alt="删除" style="margin-right: 5px" @click="todel(index)">
            </p>
          </li>
        </ul>
      </el-form-item>
      <el-form-item key="qmTypeId" label="问题类型:" prop="qmTypeId">
        <el-select  v-model="addForm.qmTypeId">
          <el-option v-for="item in dicList.checkTypeList" :key="item.id" :label="item.cnName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item key="problemTypeId" label="严重等级:" prop="problemTypeId">
        <el-radio-group v-model="addForm.problemTypeId" size="small">
          <el-radio v-for="item in dicList.severityLevelList" :key="item.id" :label="item.id">{{ item.cnName }}</el-radio>
        </el-radio-group>
      </el-form-item> -->
      <el-form-item v-if="stageNameBoolean" label="阶 段:">
        <div v-if="stageName">{{ stageName }}</div>
        <el-select v-else v-model="addForm.stageId" placeholder="请选择阶段">
          <el-option v-for="item in dicList.specStageChildVos.find(ele=>ele.name=='阶段').optionalValues" :key="item.id"
            :label="item.cnName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="childNameBoolean" label="子 项:">
        <div v-if="childName">{{ childName }}</div>
        <el-select v-else v-model="addForm.stageChildId" placeholder="请选择子项">
          <el-option v-for="item in dicList.specStageChildVos.find(ele=>ele.name == '子项').optionalValues" :key="item.id"
            :label="item.cnName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="专 业:" prop="multiSpecListspecIds">
        <!-- <div v-if="specName">{{ specName }}</div> -->
        <!-- <el-select v-model="addForm.specId" placeholder="请选择专业" @change="addForm.multiSpecListspecIds=[]">
          <el-option v-for="item in dicList.specStageChildVos.find(ele=>ele.name == '专业').optionalValues" :key="item.id"
            :label="item.cnName" :value="item.id"></el-option>
        </el-select> -->
        <el-select v-model="addForm.multiSpecListspecIds" placeholder="请选择专业" multiple collapse-tags filterable>
          <el-option v-for="item in multiSpecList" :key="item.id" :label="item.cnName" :value="item.id" ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="multiSpecNameBoolean" label="跨 专 业:">
        <div v-if="multiSpecName">{{ multiSpecName }}</div>
        <el-select v-else-if="specNameBoolean && !specName && addForm.specId" v-model="addForm.multiSpecListspecIdsaddForm.multiSpecListspecIds"
          placeholder="请选择跨专业" multiple @change="changeMultiSpecListspecIds">
          <el-option
            v-for="item in dicList.specStageChildVos.find(ele=>ele.name == '跨专业').optionalValues.filter(ele =>ele.id != addForm.specId)"
            :key="item.id" :label="item.cnName" :value="item.id"></el-option>
        </el-select>
        <el-select v-else-if="specName" v-model="addForm.multiSpecListspecIds" placeholder="请选择跨专业" multiple
          @change="changeMultiSpecListspecIds">
          <el-option
            v-for="item in dicList.specStageChildVos.find(ele=>ele.name == '跨专业').optionalValues.filter(ele =>ele.cnName != specName)"
            :key="item.id" :label="item.cnName" :value="item.id"></el-option>
        </el-select>
        <p v-else>请先选择专业</p>
      </el-form-item>
      <el-form-item label="修改方:" prop="modifierIds">
        <!-- <el-select v-model="addForm.modifierIds" multiple filterable placeholder="指定修改人">
          <el-option v-for="item in dicList.modifierList" :key="item.userId" :label="item.name" :value="item.userId"></el-option>
        </el-select> -->
        <el-select v-model="addForm.modifierIds" filterable placeholder="请选择修改方" clearable>
          <el-option-group
            v-for="group in dicList.modifierList"
            :key="group.label"
            :label="group.label"
          >
             <el-option v-for="item in group.options" :key="item.id" :label="item.cnName" :value="item.id" ></el-option>
          </el-option-group>
          </el-select>
      </el-form-item>
      <el-form-item label="位置:" prop="textProperties">
        <el-input v-model="addForm.textProperties" maxlength="20"></el-input>
      </el-form-item>
      <el-form-item style="text-align: end;">
        <el-button size="small" @click="closeModelq(true)">取消</el-button>
        <el-button v-loading="addLoading" size="small" title="模型问题" type="primary" @click="addnotations">创建</el-button>
      </el-form-item>
    </el-form>
    <check-img-point v-if="imgPoint" ref="checkImgPoint" />
    <associated-file v-if="associatedFileShow" ref="associatedFile" :prj-id="prjID" />
    <uploader ref="uploader" type-key="1" @fileAdded="fileAdded" />
  </div>
</template>

<script>
const addParamsForm = () => ({
  checkContent: '', // 问题描述
  drawingReviewPoints: '', // 审图要点
  qmTypeId: '', // 意见类型
  problemTypeId: '', // 严重等级
  stageId: '', // 阶段
  specId: '', // 专业
  multiSpecListspecIds: [], // 跨专业
  stageChildId: '', // 子项
  modifierIds: [],// 修改人
  textProperties:''
});
import { mapState } from "vuex";
import mongeService from "@/CommonDP/mongeView/service/monge-service";
import iconImage from "./images/icon-cutImg.png";
import { downloadUrltoken } from "@/CommonDP/mongeView/utils";
import { mongeApp, mongeMutations } from "@/CommonDP/mongeView/store/mongeStore";
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
import uploader from '@/CommonDP/components/UploaderForPerFileDan/Uploader.vue';
import checkImgPoint from "@/CommonDP/components/checkImgPoint/index.vue";
import associatedFile from "@/CommonDP/components/associatedFile/index.vue";
import question from "@/xgzdService/question-service"

export default {
  components: { checkImgPoint, associatedFile, uploader },
  props: ['type'],
  data() {
    return {
      dicList: [], // 添加批注的字典

      stageName: '',
      stageNameBoolean: false,
      specName: '',
      specNameBoolean: false,
      multiSpecName: "",
      multiSpecNameBoolean: false,
      childName: '',
      childNameBoolean: false,

      prjID: '',
      fileId: '',
      addLoading: false,
      base64List: [
        { url: iconImage, hasKss: false },
        { url: iconImage, hasKss: false },
        { url: iconImage, hasKss: false }
      ],
      imageIndex: '',
      rules: {
        // problemTypeId: [
        //   { required: true, message: "严重等级不可为空", trigger: "change" }
        // ],
        checkContent: [
          { required: true, message: "问题描述不可为空", trigger: "blur" }
        ],
        // qmTypeId: [
        //   { required: true, message: "意见类型不可为空", trigger: "change" }
        // ],
      },
      addForm: addParamsForm(),
      imgPoint: false,
      fileList: [],
      picList: [],
      showDelete: false,
      autoScreenshotMd5: '', // 自动截图
      coordinate: '',
      mark3d: '',
      viewPoint3d: '',
      associatedFileShow: false,
      floderData: [],
      down: require('./images/issueMgDown.png'),
      del: require('./images/issueMgDel.png'),
      sharerUserId: ""
    };
  },
  computed: {
    ...mapState({
      floderObj: (state) => state.uploaderAnnotation.floderObj,
      enterpriseId: state => state.enterprise.enterpriseId,
      modeldata: (state) => state.monge.modeldata,
    }),
    dwgdata() { // 图纸信息
      return JSON.parse(mongeApp.map.fileInfo);
    },
    integerationName() {
      if (Array.isArray(this.modelInfoData?.fileObj)) {
        return this.modelInfoData.fileObj.map(item => item.folderName).join(',')
      }
    },
    hasDwg() {
      return mongeApp.model.hasDwg;
    },
    spaceOfDwgData() {
      return mongeApp.map.spaceOfDwgData;
    },
    modelInfoData() { // 模型信息
      return JSON.parse(mongeApp.model.fileInfo);
    },
    modelPageFileName() {
      return mongeApp.model.modelPageFileName;
    },
    docmentData() { // 文件信息（非引擎）
      return JSON.parse(mongeApp.other.fileInfo);
    },
    addParams: {
      get() {
        const { checkContent, drawingReviewPoints, qmTypeId, problemTypeId, modifierIds, stageId, specId, multiSpecListspecIds, stageChildId ,textProperties} = this.addForm;
        const source = "WEB端";
        const qmType = !!this.dicList.checkTypeList && this.dicList.checkTypeList.length ? this.dicList.checkTypeList.find(item => item.id === qmTypeId).cnName : "";
        const problemType = !!this.dicList.severityLevelList && this.dicList.severityLevelList.length ? this.dicList.severityLevelList.find(item => item.id === problemTypeId).cnName : "";
        const modifierList = [];// 修改人多选
        if (modifierIds) {
          // modifierIds.forEach((ele) => {
          //   const obj = { modifierId: ele, modifierName: this.dicList.modifierList.find(sor => sor.userId == ele).name };
          //   modifierList.push(obj);
          // });
          let list = [...this.dicList.modifierList[0].options, ...this.dicList.modifierList[1].options]
          let selectItem = list.find(sor=>sor.id == modifierIds)
          let obj={modifierId:modifierIds, modifierName:selectItem.cnName, type:selectItem.remark };
          modifierList.push(obj);
        }
        const multiSpecList = [];
        // const muspecList = this.dicList.specStageChildVos ? this.dicList.specStageChildVos.find(sor => sor.name == '跨专业').optionalValues : '';
        // if (multiSpecListspecIds.length) {
        //   multiSpecListspecIds.forEach(ele => {
        //     const obj = { specId: ele, specName: muspecList.find(sor => sor.id == ele).cnName };
        //     multiSpecList.push(obj);
        //   });
        // }
        if(multiSpecListspecIds.length){
          multiSpecListspecIds.forEach(ele=>{
            let obj={specId:ele, specName:this.dicList.specList.find(sor=>sor.id == ele ).cnName }
            multiSpecList.push(obj)
          })
        }
        const stageName = stageId ? this.dicList.specStageChildVos.find(ele => ele.name == '阶段').optionalValues.find(item => item.id === stageId).cnName : "";
        // const specName = specId ? this.dicList.specStageChildVos.find(ele => ele.name == '专业').optionalValues.find(item => item.id === specId).cnName : "";
        const stageChildName = stageChildId ? this.dicList.specStageChildVos.find(ele => ele.name == '子项').optionalValues.find(item => item.id === stageChildId).cnName : "";
        let layoutName = "";// 布局空间
        let viewPoint = "";
        const autoScreenshotMd5 = this.autoScreenshotMd5 || "";
        let anchorPoint = "";
        const modelFileId = "";
        let modelPageFileName = "";
        switch (this.type) {
          case 'dwg':
            layoutName = JSON.parse(this.spaceOfDwgData);
            break;
          case 'model':
            viewPoint = JSON.stringify(this.viewPoint3d);
            break;
          case 'modelDwg':
            modelPageFileName = this.modelPageFileName;
            break;
          case 'pdf':
            anchorPoint = this.$parent.$parent.$parent.$refs.iframeID.contentWindow.PDFViewerApplication.page;
            break;
        }
        const annexFileList = [];
        if (!!this.floderData && this.floderData.length) {
          this.floderData.forEach(ele => {
            const obj = { fileId: ele.fileId, fileName: ele.fileName, id: '', uploadType: ele.uploadType };
            annexFileList.push(obj);
          });
        }
        const params = {
          textProperties,
          prjId: this.prjID,
          fileList: this.fileList,
          checkContent,
          qmTypeId,
          qmType,
          problemTypeId,
          problemType,
          modifierList,
          drawingReviewPoints,
          source,
          multiSpecList,
          stageId,
          stageName,
          specId,
          // specName,
          stageChildId,
          stageChildName,
          picMd5List: this.picList,
          layoutName,
          coordinate: this.coordinate,
          autoScreenshotMd5,
          viewPoint,
          anchorPoint,
          annexFileList,
          modelFileId,
          modelPageFileName,
          userId: this.sharerUserId,
          flowInstanceId: this.$route.query.flowInstanceId || "",
          shareId: this.$route.query.i || ""
        };
        return params;
      }
    },
    multiSpecList(){
      if(this.dicList.specList&&this.dicList.specList.length>0&&this.addForm.multiSpecListspecIds)
      return this.dicList.specList.filter(ele =>ele.id != this.addForm.multiSpecListspecIds)
    },
  },
  mounted () {
    this.init();
  },
  methods: {
    async init() {
      this.sharerUserId = this.$route.query.sharerId || "";
      if (this.type == 'dwg') {
        this.prjID = this.dwgdata.prjId;
        this.fileId = this.dwgdata.fileId;
      } else if (this.type == 'model' || this.type == 'modelDwg') {
        if (this.modelInfoData.fileObj) {
          this.fileId = '';
          this.prjID = this.modelInfoData.prjId;
        } else {
          this.fileId = this.modelInfoData.fileId;
          this.prjID = this.modelInfoData.prjId;
        }
        if (this.type == 'model') {
          this.mark3d = "";
          this.AddMark3D();
        }
      } else {
        this.fileId = this.docmentData.fileId;
        this.prjID = this.docmentData.prjId;
      }
      await this.queryDic();
    },
    focusThis(e) {
      this.$refs.eventContainer.select()
    },
    pasteFile(event) {
      const items = event.clipboardData && event.clipboardData.items
      let file = null
      if (items && items.length) {
        for (let i = 0; i < items.length; i++) {
          if (items[i].type.indexOf('image') !== -1) {
            file = items[i].getAsFile()
            break
          }
        }
        if (!file || file.size === 0) {
          this.$message.warning('没有待粘贴的文件')
          return
        }
        const reader = new FileReader()
        reader.onload = (e) => {
          this.afterChoose(e.target.result, this.imageIndex)
        }

        reader.readAsDataURL(file)
      } else {
        this.$message.warning('粘贴板中不存在图片')
      }
    },
    afterChoose(url, index) {
      this.getAddCutPicList(url, index)
    },
    syncComment() {
      console.log("syncComment-----");
      if (this.addForm.checkContent) {
        this.$emit("closeAddComment", this.addForm.checkContent , false);
      }
    },
    // 新增时候的字典
    async queryDic() {
      const res = await question.getNotationDic(this.prjID, this.fileId, this.sharerUserId);
      let list = res.data || {};
      // 处理修改方
        let roleList = { label: '角色', options: res.data.roleList };
        let userList = { label: '用户', options: res.data.userList };
        list.modifierList = [roleList, userList]
        this.dicList = list;
      this.initSpecifiedFiled()
      return
      const qmTypeId = this.$route.query.qmType ? this.dicList.checkTypeList.find(item => item.cnName === this.$route.query.qmType)?.id : "";
      this.addForm.qmTypeId = qmTypeId || res.data.qmTypeId;
      this.addForm.problemTypeId = res.data.problemTypeId;
      this.addForm.modifierIds = [];
      if (res.data.modifierId && this.dicList?.modifierList.some(e => e.userId == res.data?.modifierId)) {
        this.addForm.modifierIds = [res.data.modifierId];
      }
      if (this.dicList.specStageChildVos.some(ele => ele.name == '阶段')) {
        this.stageName = this.dicList.specStageChildVos.find(ele => ele.name == '阶段').defaultValue ;
        this.stageNameBoolean = true;
      } else {
        this.stageName = "";
        this.stageNameBoolean = false;
      }

      if (this.dicList.specStageChildVos.some(ele => ele.name == '专业')) {
        this.specName = this.dicList.specStageChildVos.find(ele => ele.name == '专业').defaultValue;
        this.specNameBoolean = true;
      } else {
        this.specName = "";
        this.specNameBoolean = false;
      }

      if (this.dicList.specStageChildVos.some(ele => ele.name == '跨专业')) {
        this.multiSpecName = this.dicList.specStageChildVos.find(ele => ele.name == '跨专业').defaultValue;
        this.multiSpecNameBoolean = true;
      } else {
        this.multiSpecName = "";
        this.multiSpecNameBoolean = false;
      }

      if (this.dicList.specStageChildVos.some(ele => ele.name == '子项')) {
        this.childName = this.dicList.specStageChildVos.find(ele => ele.name == '子项').defaultValue ;
        this.childNameBoolean = true;
      } else {
        this.childName = "" ;
        this.childNameBoolean = false;
      }
    },
    fileAdded(val) {
      if (!val.fileId) {
        this.floderData = [];
      }
      val.uploadType = 2;
      this.floderData.push(val);
    },
    AddMark3D() {
      mongeApiMlib.addMark3D('', {
        callback: async(data) => {
          this.mark3d = data;
          this.viewPoint3d = await mongeApiMlib.getViewport();
        }
      });
    },
    closeModelq() {
      if (this.type == "dwg" || this.type == 'modelDwg') {
        // Monge.Map.Annotation.clear();
        // Monge.Map.Annotation.deactive()
      } else if (this.type == "rvt") {
        // Monge.Model.Mark.clear();
        // Monge.Model.Mark.deactive()
      }
      this.floderData = [];
      this.$emit("closeAdd", '');
    },
    mouseenter(index) {
      this.imageIndex = index;
      this.showDelete = true;
    },
    mouseleave(index) {
      this.imageIndex = index;
      this.showDelete = false;
    },
    deleteImage(index) {
      this.base64List[index].url = iconImage;
      this.base64List[index].hasKss = false;
    },
    startKss(index) {
      // 图纸截图
      if (this.type == 'dwg' || this.type == 'modelDwg' || this.type == 'model') {
        this.$emit("startScreenShot", {
          callback: (data) => {
            this.getAddCutPicList(data, index);
          }
        });
      } else {
        this.$emit("startScreenShot", index);
      }
    },
    getAddCutPicList(cutimglist, index) {
      this.base64List[index].url = cutimglist;
      this.base64List[index].hasKss = true;
    },
    addnotations() {
      this.$refs.addForm.validate(async valid => {
        if (valid) {
          this.addLoading = true;
          this.picList = [];
          for (const index in this.base64List) {
            if (this.base64List[index].hasKss) {
              this.picList.push(await this.getFileMD5(this.base64List[index].url));
            }
          }
          // 图纸添加批注
          if (this.type == 'dwg') {
            this.fileList = [{ fileId: this.dwgdata.fileId, fileName: decodeURIComponent(this.dwgdata.fileName), fileVersion: this.dwgdata.fileVersion }];
            this.$emit("setCurText", this.addForm.checkContent);
          } else if (this.type == 'modelDwg' || this.type == 'model') {
            if (this.modelInfoData.fileObj) {
              this.fileList = this.modelInfoData.fileObj.map(ele => {
                return { fileId: ele.folderID, fileName: decodeURIComponent(ele.folderName), fileVersion: ele.rvtVersion };
              });
            } else {
              this.fileList = [{ fileId: this.modelInfoData.fileId, fileName: decodeURIComponent(this.modelInfoData.fileName), fileVersion: this.modelInfoData.rvtVersion }];
            }
            if (this.type == 'model') {
              if (!this.mark3d) {
                this.$message({ message: "请点击模型创建锚点", type: "warning" });
                this.addLoading = false;
                return;
              }
              this.coordinate = JSON.stringify(this.mark3d);
              await this.screenModelCapture();
            } else {
              this.$emit("setCurText", this.addForm.checkContent);
            }
          } else {
            this.$refs.checkContent.focus();
            this.$refs.checkContent.blur();
            this.coordinate = "";
            this.fileList = [{ fileId: this.docmentData.fileId, fileName: decodeURIComponent(this.docmentData.fileName), fileVersion: this.docmentData.fileVersion }];
            await this.addFinal();
          }
        }
      });
    },
    // 图纸需要用到的方法
    async screenCaptureByBox(dataUrl, data) {
      this.coordinate = data ;// 云线或锚点数据
      this.autoScreenshotMd5 = await this.getFileMD5(dataUrl);
      console.log("autoScreenshotMd5", this.autoScreenshotMd5);
      await this.addFinal();
    },
    // 模型全屏
    async screenModelCapture() {
      const type = this.hasDwg ? "modelDwg" : this.type;
      const canvas = await mongeApiMlib.mongeScreenCapture(false, type);
      this.autoScreenshotMd5 = await this.getFileMD5(canvas);
      await this.addFinal();
    },
    async addFinal() {
      this.addLoading = false;
      // try {
        
        let content = this.addForm.checkContent;
        let quote = localStorage.getItem('commentQuote');
        if(quote){
          let obj = JSON.parse(quote);
          this.addParams.pointContent = obj.quote;
          this.addParams.coordinate = obj.page;
        }
        let params = {
          ...this.addParams,
          // 基础平台兼容性调整
          picMd5List: this.addParams.picMd5List.map(pic => {
            return {
              fileMd5: pic
            }
          }),
          integerationName: this.integerationName
        }
        const res = await question.notationAdd(params);
        if (res.result === "0") {
          this.$message({ message: "创建成功！", type: "success" });
          this.addLoading = false;
          this.base64List.forEach(ele => {
            ele.url = iconImage;
            ele.hasKss = false;
          });
          this.floderData = [];
          this.addForm = addParamsForm();
          mongeMutations.changeRefreshKey();
          this.$emit("closeAdd", 'list', content);
        }
      // } catch (e) {
      //   this.addLoading = false;
      // }
    },

    async getFileMD5(base64) {
      const blob = this.dataURItoBlob(base64);
      const formData = new FormData();
      formData.set("files", blob);
      const res = await mongeService.picupload(formData);
      if (res.result === "0") {
        return res.data[0];
      }
    },
    dataURItoBlob(base64Data) {
      let byteString;
      if (base64Data.split(",")[0].indexOf("base64") >= 0) {
        byteString = atob(base64Data.split(",")[1]);
      } else {
        byteString = unescape(base64Data.split(",")[1]);
      }
      const mimeString = base64Data.split(",")[0].split(":")[1].split(";")[0];
      const ia = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([ia], { type: mimeString });
      return blob;
    },
    showImgPoint() {
      this.imgPoint = true;
      this.$nextTick(() => {
        this.$refs.checkImgPoint.showDialog();
        this.$refs.checkImgPoint.getAlldata();
      });
    },
    //  获取点击的审图要点数据
    getPointInfo(val) {
      this.addForm.drawingReviewPoints = val.mainPoint || "";
      this.imgPoint = false;
    },
    showAssociatedFile() {
      this.associatedFileShow = true;
      this.$nextTick(() => {
        this.$refs.associatedFile.showDialog();
      });
    },
    // 关联文档数据
    getAssociatedFile(val) {
      this.associatedFileShow = false;
      const arr1 = val;
      const arr2 = this.floderData;
      const arr1fileNames = new Set(arr1.map(({ fileName }) => fileName));
      const isfloderData = [...arr1, ...arr2.filter(({ fileName }) => !arr1fileNames.has(fileName))];
      const isnotfloderData = [...arr2.filter(({ fileName }) => arr1fileNames.has(fileName))];
      this.floderData = isfloderData;
      for (const key in isnotfloderData) {
        setTimeout(() => {
          this.$message.warning(`文件${isnotfloderData[key].fileName}上传失败，已存在同名文件`);
        }, 10);
      }
    },
    // 本地上传
    uploadFiles() {
      const params = {
        prjId: this.prjID,
        folderId: '',
        versionId: ""
      };
      this.$refs.uploader.openUploader(params);
      // this.$store.dispatch('annotationUploadFloderData', this.floderData);
      // this.$store.dispatch('annotationUploadType', new Date().getTime());
    },
    todown(row) {
      const prjId = this.$route.query.prjId || this.prjID;
      const fileId = row.fileId;
      window.location = downloadUrltoken(prjId, fileId, this.sharerUserId);
    },
    todel(index) {
      const obj = {};
      this.floderData = this.floderData.reduce((cur, next) => {
        obj[next.fileId] ? "" : (obj[next.fileId] = true && cur.push(next));
        return cur;
      }, []); // 设置cur默认类型为数组，并且初始值为空的数组
      this.floderData.splice(index, 1);
    },
    async changeMultiSpecListspecIds(val) {
      if (this.$custom == 'QHY') {
        const prjId = this.$route.query.prjId;
        const enterpriseId = this.$route.query.enterpriseId || this.enterpriseId ;
        const data = {
          enterpriseId,
          prjId,
          specIds: val
        };
        const multiDisciplinary = [];
        const res = await mongeService.prjPersonPlanQueryUserListRole(data);
        res.data.forEach((ele) => {
          multiDisciplinary.push(ele.userId);
        });
        const arr = this.addForm.modifierIds.concat(multiDisciplinary);
        const resc = new Map();
        this.addForm.modifierIds = arr.filter((a) => !resc.has(a) && resc.set(a, 1));
      }
    },
    initSpecifiedFiled () {
      this.initFiledWithCnName('checkTypeList', 'qmTypeId', '其他')
      this.initFiledWithCnName('severityLevelList', 'problemTypeId', 'D')
      this.initFiledWithCnName('specList', 'specId', '其他')
      this.initFiledWithCnName('specList', 'multiSpecListspecIds', '其他')
    },
    initFiledWithCnName(dictProp, formProp, cnName) {
      const dict = this.dicList
      if (Array.isArray(dict?.[dictProp])) {
        const other = dict?.[dictProp].find(item => item.cnName === cnName)
        if (other && !this.addForm[formProp]) {
          this.addForm[formProp] = other.id
        }
        if(formProp == 'multiSpecListspecIds') {
            this.$nextTick(() => { this.addForm[formProp] = [other.id] })
        }
        
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.titleShow{
  font-size: 12px;
  color: #fb3535;
}
.addStyle{
  width: 100%;
  height: 100%;
  padding-right: 7px;
  overflow: hidden;
  overflow-y: auto;
  .MQcut{
    width: 100%;
    height: 80px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .uploadpic{
      width: 75px;
      height: 75px;
      margin-right: 5px;
      cursor: pointer;
      position: relative;
      img{
        width: 100%;
        height: 100%;
      }
      .delete{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        z-index: 1px;
        cursor: pointer;
        background-color: #00000038;
        backdrop-filter: blur(2px);
        i{
          font-size:20px;
          color: #fff;
        }
      }
    }
  }
  .itemStyle {
    width: 100%;
    /deep/.el-form-item__label {
      width: 100% !important;
      display: flex;
    }
    /deep/.el-form-item__content {
      margin-top: 30px;
    }
  }
  .associatedFileStyle{
    width: 100%;
    /deep/.el-form-item__label {
      width: 100% !important;
      display: flex;
    }
    /deep/.el-form-item__content {
      margin-top: 30px;
    }
    li{
      display: flex;
      justify-content: space-between;
      color:var(--theme-color);
      cursor: pointer;
      border: 1px solid #ffffff00;
      .fileNamestyle{
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 200px;
        padding-left: 5px;
      }
    }
    li:hover{
      background:#EEF1FF;
    }
  }
  .labelStyle {
    font-size: 14px;
    line-height: 28px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 10px;
    margin-left: 20px;
    > span {
      font-size: 14px;
      line-height: 28px;
      margin-right: 10px;
    }
  }
  /deep/.el-radio{
    margin-right: 10px;
  }
  /deep/.el-select{
    width: 100%;
  }
}
</style>
